const FALLBACK_SUPABASE_URL = 'https://xkpibpevycclvtoawvyw.supabase.co';
const FALLBACK_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhrcGlicGV2eWNjbHZ0b2F3dnl3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg5ODM4MzgsImV4cCI6MjA3NDU1OTgzOH0.s-HuVNpWNsZ0Wy_OGQDE8FpBNb768i7DI7Wewx9Yc3M';

export const getEnv = () => {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || FALLBACK_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || FALLBACK_SUPABASE_ANON_KEY;
  const staxJsToken = import.meta.env.VITE_STAX_JS_TOKEN as string | undefined;
  const staxEnv = import.meta.env.VITE_STAX_ENV as string | undefined;

  if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
    console.warn('Using fallback Supabase credentials. Ensure production secrets are configured.');
  }

  // Optional: stax variables are not required for transcription
  // if (!staxJsToken) {
  //   console.warn('Missing environment variable: staxJsToken');
  // }

  // if (!staxEnv) {
  //   console.warn('Missing environment variable: staxEnv');
  // }

  return {
    supabaseUrl,
    supabaseAnonKey,
    staxJsToken,
    staxEnv,
  };
};
